module.exports = __webpack_public_path__ + "static/media/magic-wand.1531e769.png";